import { Box, Button, Spacer, ButtonProps } from '@chakra-ui/react'
import { IconDefinition, faCirclePlus } from '@fortawesome/pro-solid-svg-icons'

import { useCurrentUser } from 'src/lib/hooks/auth/useCurrentUser'

import Icon from '../../Icon/Icon'

export type SheetButtonProps = {
  title: string
  subtitle?: string
  icon?: IconDefinition
} & ButtonProps

const SheetButton = ({
  title,
  subtitle,
  isDisabled,
  icon,
  ...props
}: SheetButtonProps) => {
  const { brandColor } = useCurrentUser()
  const styleProps: ButtonProps = isDisabled
    ? {
        bg: 'air',
        color: 'graphite',
        _hover: { bg: 'air' },
      }
    : {
        bg: 'white',
        color: brandColor,
        borderColor: brandColor,
        border: '1px solid',
        _hover: { boxShadow: 'sm' },
        _active: { bg: 'air' },
      }
  return (
    <Button
      px={4}
      py={subtitle ? 4 : 5}
      paddingX={4}
      paddingY={subtitle ? 4 : 5}
      borderRadius={12}
      isDisabled={isDisabled}
      {...styleProps}
      {...props}
    >
      <Box minW={0} textAlign="left">
        <Box fontSize="1.4rem">{title}</Box>
        {!!subtitle && (
          <Box
            mt={3}
            className="body-extra-small"
            wordBreak="break-word"
            whiteSpace="break-spaces"
            color={isDisabled ? 'stone' : brandColor}
            w="100%"
          >
            {subtitle}
          </Box>
        )}
      </Box>
      <Spacer />
      <Icon icon={icon || faCirclePlus} ml={4} fontSize={20} />
    </Button>
  )
}

export default SheetButton
